'use client'

import { useEffect, useState } from 'react'

/** Wall-clock ticking every `intervalMs` — drives RFQ countdowns and client-side expiry. */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
